import { useIMask } from 'react-imask';
import { TextField, TextFieldProps } from '@mui/material';
import { useRef } from 'react';

type IMaskInputProps = TextFieldProps & {
    mask?: string; // Define the mask type, can be a string or an object
    lazy?: boolean; // Whether to show placeholder when empty
    overwrite?: boolean; // Whether to overwrite input instead of inserting
    cursorStart?: number; // Start position of the cursor
    defaultValue?: string; // Default value for the input
    defaultUnmaskedValue?: string; // Default unmasked value for the input
    defaultTypedValue?: string; // Default typed value for the input
    onAccept?: (value: string, maskRef: any) => void; // Callback when value is accepted
}
// The main component that combines TextField with IMask
const ImaskInput: React.FC<IMaskInputProps> = (props: IMaskInputProps) => {
    const {
        mask,
        lazy, // Default to true if not provided
        overwrite,
        cursorStart, // Default to 0 if not provided
        defaultValue,
        defaultUnmaskedValue,
        defaultTypedValue,
        onAccept,
        ...textFieldProps
    } = props;

    const ref = useRef<HTMLInputElement>(null);
    
    const {
        maskRef,
        value,
        setValue,
        unmaskedValue,
        setUnmaskedValue,
        typedValue,
        setTypedValue,
    } = useIMask({
        mask: mask || '00:00',
        lazy: lazy, // Default to true if not provided
        overwrite: overwrite,
        placeholderChar: '0', // Character to use as placeholder
    },{
        // Additional options can be passed here
        onAccept: (value, maskRef) => {
            // Handle the value change if needed
            console.log('Value accepted:', value);
            //replace _ with a zero but keep the cursor position
            const inputRef = ref.current as HTMLInputElement;
            const currentValue = inputRef.value;
            if (inputRef && currentValue) {
                const newValue = currentValue.replace(/_/g, '0');
                if (newValue !== currentValue) {
                    setValue(newValue);
                    inputRef.value = newValue; // Update the input value
                }
            }
            if (onAccept) {
                onAccept(value, maskRef);
            }
        },
        onComplete: (value, maskRef) => {
            // Handle the completion of input if needed
            console.log('Input completed:', value);
        },
        ref,
        defaultValue,
        defaultUnmaskedValue,
        defaultTypedValue,
    });

    const handleFocus = () => {
        // Esperamos un momento para asegurar que el input recibió el foco
        
        setTimeout(() => {
            const inputRef = ref.current as HTMLInputElement;
            if (inputRef) {
                if (inputRef.setSelectionRange && cursorStart !== undefined) {
                    console.log('Setting cursor position to:', cursorStart);
                    inputRef.setSelectionRange(cursorStart, cursorStart+1)
                }
            }
        }, 100);
    }

    return (
        <TextField
            {...textFieldProps}
            inputRef={ref}

            onFocus={handleFocus}
        />
    );
};

export default ImaskInput;